module.exports = __webpack_public_path__ + "static/img/defultDirect.e2bfac7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/defult/img/defultDirect.png
// module id = hTdC
// module chunks = 1